import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../../../utils/classnames';

const DashboardTab = ({
  label,
  active,
  onClick,
  inactiveColor = 'bg-white text-blueDarker border-blueLight hover:bg-blueSoft',
  py = 'py-4',
  icon: Icon,
  style = 'default',
}) => {
  return (
    <button
      onClick={onClick}
      className={cn(
        py,
        'flex justify-center gap-2 items-center px-4 text-center rounded-xl border transition-all font-semibold flex-grow',
        active ? 'bg-tealLight text-white' : inactiveColor,
        style === 'default' ? 'text-sm' : 'text-xs'
      )}
    >
      {/* Aqui você usa o nome renomeado (Icon) para verificar e renderizar */}
      {Icon && <Icon size={18} className={cn(active ? 'text-white' : 'text-blueDarker')} strokeWidth={1.5} />}
      <span>{label}</span>
    </button>
  );
};

export default DashboardTab;
